import { BodyBox } from '@lbcamden/lib-react';
import { formatDMY } from '@lbcamden/shared-utils';
import { FunctionComponent } from 'react';
import { useParams } from 'react-router';

import { useProperty, useServiceRequest } from '~/client/hooks/storeHooks';
import { getPropertyBreadcrumbs } from '~/client/utils/navigation';

import { ItemDetails } from '../../common/ItemDetails';
import { PageTitle } from '../../common/PageTitle';
import { PageBreadcrumbs } from '../../shared/PageBreadcrumbs';
import { LoadInNotFoundPage } from '../LoadInNotFoundPage';
import { ServiceRequestNotes } from './ServiceRequestNotes';
import { WorksOrders } from './WorksOrders';

export const ServiceRequestPage: FunctionComponent = () => {
  const { propertyId: propertyIdParam, serviceRequestId: serviceRequestParam } = useParams();
  const propertyId = parseInt(propertyIdParam!);
  const serviceRequestId = parseInt(serviceRequestParam!);

  const property = useProperty(propertyId);
  const serviceRequestItem = useServiceRequest(serviceRequestId);

  if (!property || !serviceRequestItem) {
    return <LoadInNotFoundPage />;
  }

  const serviceRequestName = `Service request ${serviceRequestId}`;

  return (
    <BodyBox>
      <PageTitle title={serviceRequestName} />
      <PageBreadcrumbs
        links={[...getPropertyBreadcrumbs(property), { name: serviceRequestName }]}
      />
      <ItemDetails
        css={{ paddingBottom: 0 }}
        titleLabel="Service request"
        title={serviceRequestItem.description}
        information={[
          ['Type', serviceRequestItem.isPropertyRequest ? 'Dwelling' : 'Communal'],
          ['Status', serviceRequestItem.status],
          ['Priority code', serviceRequestItem.priorityCode],
          ['Service request ID', serviceRequestId],
          ['Created date', formatDMY(serviceRequestItem.createdDate)],
          ['Reported date', formatDMY(serviceRequestItem.reportedDate)],
          ['Target date', formatDMY(serviceRequestItem.targetDate)],
          [
            'Last modified date',
            serviceRequestItem.modifiedDate && formatDMY(serviceRequestItem.modifiedDate),
          ],
        ]}
        sections={[
          {
            title: 'Works orders',
            content: <WorksOrders propertyId={propertyId} serviceRequestId={serviceRequestId} />,
          },
        ]}
      />
      <ServiceRequestNotes propertyId={propertyId} serviceRequestId={serviceRequestId} />
    </BodyBox>
  );
};
